export * from './level-slider-view.component';
export * from './level-slider-view.module';
